import { Fragment } from 'react';
import { useFormikContext } from 'formik';
import BN from 'bn.js';

import { Button } from 'components/common/button/button';
import {
  StyledInputMount,
  StyledButtonWrapper,
  StyledInputWrapper,
  StyledInputLabel,
  StyledInputValue,
  StyledTitle,
} from '../../withdraw-storage-view.style';

import { useAppSelector } from 'redux/use-hooks';
import { selectActiveToken } from 'redux/slices/tokens';
import { selectStorageBalance } from 'redux/slices/account';
import { getFontSize, getFieldProps, isValidAmount } from 'utils';
import { FormValues } from 'types';
import FungibleTokens from 'services/fungible-tokens';
import config from 'config';

const { OCC_CONTRACT } = config;

const { getFormattedTokenAmount } = FungibleTokens;

const EnterAmountTabs = ({ isLoading }) => {
  const formik = useFormikContext<FormValues>();
  const { values, setFieldValue } = formik;
  const nearTokenBalance = useAppSelector(selectActiveToken);
  const storageBalance = useAppSelector(selectStorageBalance);
  const occStorageBalance = storageBalance[OCC_CONTRACT];

  const handleUseMax = () => {
    const formattedTokenAmount = getFormattedTokenAmount(
      occStorageBalance.available,
      nearTokenBalance.onChainFTMetadata.symbol
    );
    if (!new BN(occStorageBalance.available).isZero()) {
      setFieldValue('amount', formattedTokenAmount.replace(/,/g, ''));
    }
  }

  const isDisabled = () => {
    if (isLoading) return true;
    if (!(isValidAmount(formik.values.amount) && formik.isValid)) return true;
    return false;
  };

  return (
    <Fragment>
      <StyledInputMount
        required
        autoFocus
        style={{
          fontSize: `${
            values.amount.length ? getFontSize(values.amount.length) : 64
          }px`
        }}
        {...getFieldProps(formik, 'amount')}
      />
      <StyledButtonWrapper>
        <Button
          type="button"
          variant="secondary"
          size="small"
          onClick={() => handleUseMax()}
        >
          Use Max
        </Button>
      </StyledButtonWrapper>
      <StyledInputWrapper>
        <StyledInputLabel>Storage Deposit Available</StyledInputLabel>
        <StyledInputValue>
          {getFormattedTokenAmount(
            occStorageBalance.available,
            nearTokenBalance.onChainFTMetadata.symbol
          )}
        </StyledInputValue>
      </StyledInputWrapper>
      <Button type="submit" disabled={isDisabled()} loading={isLoading} fullwidth>
        Confirm
      </Button>
    </Fragment>
  )
};

const EnterAmountView = ({ isLoading }) => {
  return (
    <Fragment>
      <StyledTitle mb="130px">Withdraw Storage</StyledTitle>
      <EnterAmountTabs isLoading={isLoading} />
    </Fragment>
  )
};

export default EnterAmountView;
